import request from "@/utils/request";

export default function agentChargeMoney(params) {
    return request({
        url: `/user/card/agentChargeMoney`,
        method: 'post',
        params: params
    })
}
